/** Matches GET /me/notifications?mCode= (PortalUserScopedNotificationPreferencesDto). */
export interface NotificationPreferences {
  mCode: string;
  masterClientName: string;
  /** Null when the user cannot configure this type for the MCode. */
  billingEnabled: boolean | null;
  enrollmentEnabled: boolean | null;
  cancellationEnabled: boolean | null;
  /** True when at least one saved preference row exists for this MCode. */
  hasConfiguredPreferences: boolean;
}

/** Matches PortalUserNotificationType (Billing | Enrollment | Cancellation). */
export type NotificationTypeApi = 'Billing' | 'Enrollment' | 'Cancellation';

/** One row in POST /me/notifications changes[]. */
export interface SaveNotificationPreferenceChange {
  notificationType: NotificationTypeApi;
  mCode: string;
  enabled: boolean;
}

/** Matches POST /me/notifications body. */
export interface SaveNotificationPreferencesRequest {
  changes: SaveNotificationPreferenceChange[];
}

export type NotificationPreferenceType = 'billing' | 'enrollment' | 'cancellation';

export const NOTIFICATION_TYPE_TO_API: Record<NotificationPreferenceType, NotificationTypeApi> = {
  billing: 'Billing',
  enrollment: 'Enrollment',
  cancellation: 'Cancellation'
};

export function normalizeNotificationPreferences(
  source: Partial<NotificationPreferences> | null | undefined
): NotificationPreferences {
  return {
    mCode: source?.mCode ?? '',
    masterClientName: source?.masterClientName ?? '',
    billingEnabled: source?.billingEnabled ?? null,
    enrollmentEnabled: source?.enrollmentEnabled ?? null,
    cancellationEnabled: source?.cancellationEnabled ?? null,
    hasConfiguredPreferences: source?.hasConfiguredPreferences ?? false
  };
}

export function emptyNotificationPreferences(): NotificationPreferences {
  return normalizeNotificationPreferences(null);
}
